// Sidebar nav. Each item carries the permission that gates its visibility; the
// Sidebar and CommandPalette hide items the session can't access.
export type NavItem = { label: string; icon: string; to: string; perm: string; badge?: number }
export type NavGroup = { label: string; items: NavItem[] }

export const NAV: NavGroup[] = [
  {
    label: 'Overview',
    items: [
      { label: 'Dashboard', icon: 'gauge', to: '/', perm: 'view:dashboard' },
      { label: 'Transactions', icon: 'money', to: '/transactions', perm: 'view:transactions' },
    ],
  },
  {
    label: 'Money',
    items: [
      { label: 'Accounts', icon: 'bank', to: '/accounts', perm: 'view:accounts' },
    ],
  },
  {
    label: 'Rails',
    items: [{ label: 'Gateways', icon: 'rails', to: '/gateways', perm: 'view:gateways' }],
  },
  {
    label: 'Oversight',
    items: [{ label: 'Audit log', icon: 'audit', to: '/audit', perm: 'view:audit' }],
  },
  {
    label: 'Administration',
    items: [
      { label: 'Users & roles', icon: 'clients', to: '/users', perm: 'manage:rbac' },
      { label: 'Roles & permissions', icon: 'shield', to: '/roles', perm: 'manage:rbac' },
      { label: 'System config', icon: 'admin', to: '/config', perm: 'manage:config' },
    ],
  },
]
